<template>
  <component
    :is="item.link ? 'a' : 'div'"
    :href="item.link"
    rel="noopener"
    class="review"
    target="_blank"
    :class="{ 'review--product': isProductReview, 'review--account': isAccountReview }"
    :style="`background-image: ${foreground};`"
    @click="clickHandler">
    <div
      v-if="!isAccountReview"
      class="review__header">
      <div
        class="review__title"
        :title="title">
        {{ title }}
      </div>
    </div>

    <div class="review__rate">
      <ui-rate
        class="review__rate-stars"
        :value="Number(item.stars)"
        :show-rate-number="false"
        :star-key="item.key || Date.now()"
        is-read-only />
      <div
        v-if="!isAccountReview"
        class="review__rate-user">
        <div
          class="review__name"
          :title="item.author">
          {{ item.author }}
        </div>
      </div>
    </div>

    <div
      v-if="isAccountReview"
      class="review__title"
      :title="title">
      {{ title }}
    </div>

    <div class="review__comment">
      {{ item.review }}
    </div>

    <div
      v-if="isAccountReview"
      class="review__footer">
      <p
        class="review__name"
        :title="item.author">
        {{ item.author }}
      </p>
      <p class="review__date">
        {{ item.date }}
      </p>
    </div>
  </component>
</template>

<script>
import { mapGetters } from 'vuex';
import MobileAppMessagingDriver from 'Root/drivers/MobileAppMessagingDriver';
import GameModel from 'Models/GameModel';
import UiRate from 'Components/ui/Rating/UiRate.vue';

export default {
  name: 'ReviewItem',
  components: { UiRate },

  props: {
    item: {
      type: Object,
      required: true,
    },

    gameId: {
      type: [Number, String],
      default: null,
    },

    isProductReview: {
      type: Boolean,
      default: false,
    },

    isAccountReview: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      GameModel,
    };
  },

  computed: {
    ...mapGetters(['isPlatformApp']),

    title() {
      return this.isProductReview ? this.item.title : (this.item.service || this.item.title);
    },

    foreground() {
      return !this.isProductReview && this.item.foreground ? `url(${this.item.foreground})` : 'none';
    },
  },

  methods: {
    clickHandler(event) {
      if (this.item.link && this.isPlatformApp) {
        event.preventDefault();
        MobileAppMessagingDriver.openUrl(this.item.link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.review {
  position: relative;
  min-width: 206px;
  width: 206px;
  padding: 16px 20px 31px;
  min-height: 237px;
  background-repeat: no-repeat;
  background-size: auto 65%;
  background-position: 150% bottom;
  border-radius: 10px;
  overflow: hidden;
  scroll-snap-align: start;
  color: $color--basic-white;

  &:before {
    content: '';
    background: url(/images/reviews/bg__500x500.jpg) no-repeat center center/cover;
    opacity: .55;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    border-radius: 15px;
  }
}

.review--product {
  padding: 20px;
  min-height: 211px;
  background-image: none;

  .review__comment {
    width: 100%;
    -webkit-line-clamp: 5;
  }

  .review__rate {
    margin-bottom: 13px;
  }

  .review__rate-user {
    width: 100%;
  }

  .review__rate-stars {
    margin-bottom: 11px;
  }
}

.review__header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.review__title {
  font-weight: 500;
  font-size: $text-13px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.review__rate {
  display: flex;
  flex-direction: column;
  margin-bottom: 17px;
}

.review__rate-stars {
  --star-size: 18px;

  width: 91px;
  height: auto;
  margin-bottom: 8px;
  transform: scale(0.75) translateY(-15%);
  transform-origin: left top;
}

.review__rate-user {
  display: flex;
  width: calc(100% - 30px);
}

.review__name {
  font-weight: 500;
  font-size: $text-13px;
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

//.review__date {
//  font-weight: 300;
//  font-size: $text-13px;
//  color: $color--basic-light-gray;
//}

.review__comment {
  //width: calc(100% - 60px);
  width: 100%;
  font-weight: 300;
  font-size: $text-13px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}

@media only screen and #{$screen-more-or-1024} {
  .review {
    //min-width: 337px;
    min-width: 300px;
    width: auto;
    height: 237px;
    //padding: 33px 96px 40px 34px;
    padding: 33px 34px 40px 34px;
    background-size: auto 80%;
    background-position: right bottom;
  }

  .review--product {
    min-width: 293px;
    min-height: 214px;
    padding: 24px 34px 15px 24px;
    background-size: 100%;

    .review__rate-stars {
      margin-bottom: 0;
    }

    .review__rate-user {
      width: calc(100% - 104px);
    }
  }

  .review__header {
    display: flex;
    align-items: center;
    margin-bottom: 13px;
  }

  .review__title {
    font-size: $text-15px;
    width: 149px;
  }

  .review__rate {
    flex-direction: row;
    align-items: center;
    margin-bottom: 14px;
  }

  .review__rate-user {
    width: calc(100% - 104px);
    align-items: center;
    max-width: 230px;
  }

  .review__rate-stars {
    margin-bottom: 0;
    margin-right: 13px;
  }
}

.review--account {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: auto;
  min-width: 280px;
  min-height: 0;
  padding: 20px;
  background-color: $color--basic-menu;
  border-radius: 16px 16px 16px 0;

  &:before {
    display: none;
  }

  .review__rate {
    margin-bottom: 0;
  }

  .review__rate-stars {
    --star-size: 20px;
  }

  /deep/.ui-rate__stars {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  /deep/.ui-rate__star {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .review__rate-stars {
    width: auto;
    height: auto;
    margin-bottom: 0;
    transform: none;
    transform-origin: center;
  }

  .review__title {
    width: 100%;
    margin: 0;
    font-weight: 500;
    font-size: $text-19px;
    line-height: normal;
  }

  .review__comment {
    font-weight: 400;
    font-size: $text-13px;
    line-height: 1.4;
  }

  .review__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: auto;
  }

  .review__name {
    font-weight: 500;
    font-size: $text-13px;
    line-height: 1.4;
  }

  .review__date {
    font-weight: 400;
    font-size: $text-13px;
    line-height: normal;
    color: $color--basic-dark-gray;
  }

  @media only screen and #{$screen-more-or-640} {
    min-width: 0;
  }

  @media only screen and #{$screen-more-or-1024} {
    min-width: 0;
  }

  @media screen and (max-width: 799px) {
    min-width: 280px;
  }
}
</style>
